export const databaseConnection = "pua-authentication";
export const organizationDataUrl = "%%ORGANIZATIONS_API%%";

export const manageCookiesText = "Manage Cookies";

// general links
export const feedbackLink = "https://health.ebsco.com/";
export const copyrightLink =
  "http://support.ebscohost.com/ehost/terms.html#copyright";
export const privacyPolicyLink = "https://www.ebsco.com/company/privacy-policy";
export const disclaimerLink = "https://www.ebsco.com/company/legal-disclaimer";
export const termsOfUseLink = "ebsco-policies/terms-of-use.md";

// dmp/dmx shared links
export const dmpHelpLink =
  "http://support.ebsco.com/help/?int=dynamed&ver=live";

  export const dmxHelpLink =
  "http://support.ebsco.com/help/?int=dmx&ver=live";

// dh links
export const dhHelpLink =
  "https://connect.ebsco.com/s/topic/0TO1H000000HHfCWAW/dynamic-health?language=en_US";
